module.exports = __webpack_public_path__ + "static/media/general-purchase.9b2c3692.svg";